<template>
  <div id="scroll-target">
    <vs-row class="mb-2">
      <vs-col vs-type="flex" vs-lg="7" vs-sm="12" class="m-0 p-0"> </vs-col>
      <vs-col vs-align="flex-end" vs-lg="5" vs-sm="12" class="m-0 p-0">
        <div class="text-right hidden lg:inline-block" style="float: right">
          <ul class="demo-alignment pb-0" style="float: right">
            <li class="pl-4 border-0 border-solid border-grey">
              <i
                class="fas fa-file-download fa-2x cursor-pointer hover:text-primary"
                @click="onExport()"
              ></i>
            </li>
          </ul>
        </div>
      </vs-col>
    </vs-row>
    <vs-card>
      <b-table
        ref="table"
        style="min-height: 600px;"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :foot-clone="true"
        no-footer-sorting
        :no-provider-sorting="true"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height:600px;">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>
        <!-- 
        <template v-slot:head(order_id)="data">
          <span class="text-info">{{ data.label.toUpperCase() }}</span>
        </template>-->

        <template v-slot:cell(rowstatus)="data">
          <div>
            <vs-chip v-bind:class="data.value.toLowerCase()">{{
              data.value.toUpperCase().replace(" ", "")
            }}</vs-chip>
          </div>
        </template>
        <template v-slot:cell(order_id)="data">
          <div style="width:70px;">{{ data.value }}</div>
        </template>
        <template v-slot:cell(unique_id)="data">
          <div style="width:70px;">{{ data.value }}</div>
        </template>
        <template v-slot:cell(name)="data">
          <div style="width:150px;">
            {{ data.value.first }}
            <br />
            {{ data.value.last }}
          </div>
        </template>

        <template v-slot:cell(amount)="data">
          <div style="width:150px;">{{ data.value | numFormat("0,0.00") }}</div>
        </template>

        <template v-slot:cell(quantity)="data">
          <div>
            <vs-button
              @click="openTicket(data.item)"
              type="border"
              class
              color="grey"
              >{{ data.value }}</vs-button
            >
          </div>
        </template>

        <template v-slot:cell(upload)="data">
          <i v-if="data.value != 'n'" class="far fa-file-image fa-2x"></i>
          <span v-else>N</span>
        </template>

        <template v-slot:cell(approve)="data">
          <i v-if="data.value == 'y'" class="fas fa-check fa-2x"></i>
          <span v-if="data.value == 'n'">N</span>
        </template>

        <template v-slot:cell(email)="data">
          <div style="width:150px;">{{ data.value }}</div>
        </template>

        <template v-slot:cell(paidby)="data">
          <div>
            <i
              v-if="data.value == 'creditcard'"
              class="far fa-credit-card fa-2x"
            ></i>
            <i
              v-if="data.value == 'transfer'"
              class="fas fa-exchange-alt fa-2x"
            ></i>
          </div>
        </template>

        <template v-slot:cell(actions)="data">
          <b-dropdown size="sm" text="Actions" variant="outline-danger">
            <b-dropdown-item v-for="(item, index) in data.value" :key="index">
              <i :class="item.icon" class="cursor-pointer"></i>
              {{ item.text }}
            </b-dropdown-item>
          </b-dropdown>
        </template>

        <!-- A custom formatted footer cell for field 'name' -->
        <template #foot()="data">
          <div style="font-weight:bolder; font-size:1.1rem;">
            <b>{{ data.field.foot }}</b>
          </div>
        </template>
      </b-table>
      <!--
      <data-table :columns="columns" :data="data" @onTablePropsChanged="reloadTable"></data-table>
      -->
      <div v-if="showPagination" class="mt-3 text-right">
        <vs-pagination
          :total="Math.ceil(totalRows / 30)"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        ></vs-pagination>

        <div class="mt-3">{{ from }} to {{ to }} of {{ totalRows }} orders</div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import Service from "@/services";
import XLSX from "xlsx"; // import xlsx
export default {
  components: {},
  data: () => ({
    order_id: null,
    showPagination: false,
    isBusy: false,
    currentPage: 1,
    perPage: 1000,
    totalRows: 0,
    selected: [],
    search: "",
    filter: "",
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    columns: [
      { label: "Year", key: "Year", sortable: true, foot: "" },
      { label: "Date", key: "Date", sortable: true, foot: "" },
      { label: "Orders", key: "Orders", sortable: true, foot: "" },
      { label: "Paid", key: "Paid", sortable: true, foot: "" },
      { label: "Rate", key: "PaidRatio", sortable: true, foot: "" },
      { label: "Revenue", key: "Revenue", sortable: true, foot: "" },
      { label: "Pending", key: "PaymentPending", sortable: true, foot: "" },
      { label: "Transfer", key: "Transfer", sortable: true, foot: "" },
      { label: "Amount", key: "TransferAmount", sortable: true, foot: "" },
      { label: "Credit Card", key: "creditcard", sortable: true, foot: "" },
      { label: "Amount", key: "CreditcardAmount", sortable: true, foot: "" },
      { label: "Tickets", key: "Tickets", sortable: true, foot: "" }
    ],
    items: []
  }),
  watch: {},
  created() {
    this.order_id = this.$route.query.o;
  },
  methods: {
    debounceInput: _.debounce(function(e) {
      this.filter = e;
      this.search = e;
    }, 500),
    dataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          e: this.$route.query.e
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map(key => key + "=" + ctx[key])
            .join("&");

        return Service.Report.overview(params)
          .then(res => {
            this.data = res.data;

            let footerRow = res.data[res.data.length - 1];
            for (var key in footerRow) {
              if (footerRow.hasOwnProperty(key)) {
                let index = this.columns.findIndex(x => x.key == key);
                if (index >= 0) {
                  this.columns[index].foot = footerRow[key];
                }
              }
            }
            this.data.pop();
            callback(this.data);
          })
          .catch(error => {
            callback([]);
          });
      }, 500);
    },
    onExport() {
      let rows = [];
      let days = [];

      let header = this.columns.map((item, index) => {
        return { text: item.label };
      });

      rows = this.data.map(item => {
        return {
          Year: item.Year,
          Date: item.Date,
          Orders: item.Orders,
          Paid: item.Paid,
          Rate: item.PaidRatio,
          Revenue: item.Revenue,
          Pending: item.PaymentPending,
          Transfer: item.Transfer,
          Amount: item.TransferAmount,
          "Credit Card": item.creditcard,
          "Credit Card Amount": item.CreditcardAmount,
          Tickets: item.Tickets
        };
      });

      let dataExport = {};
      const dataWS = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "sale_report.xlsx");
      this.$vs.loading.close();
    }
  }
};
</script>
